{{ basePanelService.routeData.viewTitle ? (basePanelService.routeData.viewTitle! | translate) : '' }}
